import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import UnifiedClubWidget from '../components/widgets/UnifiedClubWidget';

const WidgetPage: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const [searchParams] = useSearchParams();

  const theme = (searchParams.get('theme') || 'light') as 'light' | 'dark';
  const lang = (searchParams.get('lang') || 'en') as 'en' | 'fr' | 'de' | 'it';
  const defaultTab = searchParams.get('tab') as 'overview' | 'matches' | 'teams' | 'players' | 'venues' || 'overview';
  const compact = searchParams.get('compact') === 'true';

  // Remove default margin/padding for iframe embedding
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.backgroundColor = 'transparent';
  }, []);

  if (!clubId) {
    return (
      <div className="p-4 text-center text-red-600">
        <p>Club ID is required</p>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen p-2">
      <UnifiedClubWidget
        clubId={clubId}
        theme={theme}
        lang={lang}
        defaultTab={defaultTab}
        compact={compact}
      />
    </div>
  );
};

export default WidgetPage;
